"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.queries = void 0;
exports.queries = {
    vAb0: {
        interpretation: {
            vocab: "ltx",
            code: "ab0"
        }
    },
    vRh: {
        interpretation: {
            vocab: "ltx",
            code: "rh"
        }
    },
    weight: {
        interpretation: {
            vocab: "ltx",
            code: "weight"
        }
    },
    height: {
        interpretation: {
            vocab: "ltx",
            code: "height"
        }
    },
    bmi: {
        interpretation: {
            vocab: "ltx",
            code: "bmi"
        }
    },
    patientStatus: {
        interpretation: {
            vocab: "ltx",
            code: "patient_status"
        }
    },
    urgency: {
        interpretation: {
            vocab: "ltx",
            code: "urgency"
        }
    },
    signedStatementOfConsent: {
        interpretation: {
            vocab: "ltx",
            code: "signed_statement_of_consent_timm"
        }
    },
    waitingListStartDate: {
        interpretation: {
            vocab: "ltx",
            code: "waiting_list_start_date"
        }
    },
    patientEtId: {
        interpretation: {
            vocab: "ltx",
            code: "patient_et_id"
        }
    },
    combinedTransplant: {
        interpretation: {
            vocab: "ltx",
            code: "combined_transplant"
        }
    },
    hyperImmunised: {
        interpretation: {
            vocab: "ltx",
            code: "hyper_immunised"
        }
    },
    summaryReport: {
        interpretation: {
            vocab: "ltx",
            code: "medical_history_summary"
        }
    },
    chestXray: {
        interpretation: {
            vocab: "ltx",
            code: "chest_x_ray_result"
        },
        limit: Infinity
    },
    chestCt: {
        interpretation: {
            vocab: "ltx",
            code: "chest_ct_result"
        },
        limit: Infinity
    },
    abdominalUltrasound: {
        interpretation: {
            vocab: "ltx",
            code: "abdominal_ultrasound_result"
        },
        limit: Infinity
    },
    urology: {
        interpretation: {
            vocab: "ltx",
            code: "urology_result"
        }
    },
    gynecology: {
        interpretation: {
            vocab: "ltx",
            code: "gynecology_result"
        }
    },
    ophthalmologicExamination: {
        interpretation: {
            vocab: "ltx",
            code: "ophthalmologic_examination_result"
        }
    },
    earNoseThroat: {
        interpretation: {
            vocab: "ltx",
            code: "ear_nose_throat"
        }
    },
    dentalScreening: {
        interpretation: {
            vocab: "ltx",
            code: "dental_screening_result"
        }
    },
    cmv: {
        interpretation: {
            vocab: "ltx",
            code: "cmv_igg"
        }
    },
    ebvSerology: {
        interpretation: {
            vocab: "ltx",
            code: "ebv_serology_igg"
        }
    },
    toxoplasmaSerology: {
        interpretation: {
            vocab: "ltx",
            code: "toxoplasma_serology_igg"
        }
    },
    varicellaSerology: {
        interpretation: {
            vocab: "ltx",
            code: "varicella_serology_igg"
        }
    },
    hsv1Serology: {
        interpretation: {
            vocab: "ltx",
            code: "hsv1_serology_igg"
        }
    },
    hsv2Serology: {
        interpretation: {
            vocab: "ltx",
            code: "hsv2_serology_igg"
        }
    },
    syphilisScreening: {
        interpretation: {
            vocab: "ltx",
            code: "treponema_pallidum_org_screening_procedure"
        }
    },
    hivScreening: {
        interpretation: {
            vocab: "ltx",
            code: "hiv_screening"
        }
    },
    greenLight: {
        interpretation: {
            vocab: "ltx",
            code: "green_light"
        }
    },
    abdominalCt: {
        interpretation: {
            vocab: "ltx",
            code: "abdominal_ct_result"
        },
        limit: Infinity
    },
    abdominalMri: {
        interpretation: {
            vocab: "ltx",
            code: "abdominal_mri_result"
        },
        limit: Infinity
    },
    craniumCt: {
        interpretation: {
            vocab: "ltx",
            code: "cranium_ct_result"
        },
        limit: Infinity
    },
    craniumMr: {
        interpretation: {
            vocab: "ltx",
            code: "cranium_mr_result"
        },
        limit: Infinity
    },
    gastroscopia: {
        interpretation: {
            vocab: "ltx",
            code: "gastroscopia_result"
        },
        limit: Infinity
    },
    lumbarSpineXRay: {
        interpretation: {
            vocab: "ltx",
            code: "lumbar_spine_x_ray_result"
        },
        limit: Infinity
    },
    asciticFluidCulture: {
        interpretation: {
            vocab: "ltx",
            code: "ascitic_fluid_culture_result"
        }
    },
    nasalSwabCulture: {
        interpretation: {
            vocab: "ltx",
            code: "nasal_swab_culture_result"
        }
    },
    stoolCulture: {
        interpretation: {
            vocab: "ltx",
            code: "stool_culture_result"
        }
    },
    throatSwabCulture: {
        interpretation: {
            vocab: "ltx",
            code: "throat_swab_culture_result"
        }
    },
    urineCulture: {
        interpretation: {
            vocab: "ltx",
            code: "urine_culture_result"
        }
    },
    neurology: {
        interpretation: {
            vocab: "ltx",
            code: "neurology_result"
        }
    },
    fvs: {
        interpretation: {
            vocab: "ltx",
            code: "fvs"
        }
    },
    haemoglobin: {
        interpretation: {
            vocab: "ltx",
            code: "haemoglobin"
        }
    },
    plateletCount: {
        interpretation: {
            vocab: "ltx",
            code: "platelet_count"
        }
    },
    gfr: {
        interpretation: {
            vocab: "ltx",
            code: "gfr"
        }
    },
    creatinine: {
        interpretation: {
            vocab: "ltx",
            code: "creatinine"
        }
    },
    karbamid: {
        interpretation: {
            vocab: "ltx",
            code: "karbamid"
        }
    },
    natrium: {
        interpretation: {
            vocab: "ltx",
            code: "natrium"
        }
    },
    potassium: {
        interpretation: {
            vocab: "ltx",
            code: "potassium"
        }
    },
    got: {
        interpretation: {
            vocab: "ltx",
            code: "got"
        }
    },
    gpt: {
        interpretation: {
            vocab: "ltx",
            code: "gpt"
        }
    },
    ggt: {
        interpretation: {
            vocab: "ltx",
            code: "ggt"
        }
    },
    alkalinePhosphatase: {
        interpretation: {
            vocab: "ltx",
            code: "alkaline_phosphatase"
        }
    },
    bilirubinTotal: {
        interpretation: {
            vocab: "ltx",
            code: "bilirubin_total"
        }
    },
    bilirubinDirect: {
        interpretation: {
            vocab: "ltx",
            code: "bilirubin_direct"
        }
    },
    serumGlucose: {
        interpretation: {
            vocab: "ltx",
            code: "serum_glucose"
        }
    },
    crp: {
        interpretation: {
            vocab: "ltx",
            code: "crp"
        }
    },
    ldh: {
        interpretation: {
            vocab: "ltx",
            code: "ldh"
        }
    },
    hgbA1C: {
        interpretation: {
            vocab: "ltx",
            code: "hgb_a1_c"
        }
    },
    inr: {
        interpretation: {
            vocab: "ltx",
            code: "inr"
        }
    },
    pseudocholinesterase: {
        interpretation: {
            vocab: "ltx",
            code: "pseudocholinesterase"
        }
    },
    prealbumin: {
        interpretation: {
            vocab: "ltx",
            code: "prealbumin"
        }
    },
    tsh: {
        interpretation: {
            vocab: "ltx",
            code: "tsh"
        }
    },
    t3: {
        interpretation: {
            vocab: "ltx",
            code: "t3"
        }
    },
    t4: {
        interpretation: {
            vocab: "ltx",
            code: "t4"
        }
    },
    coombsDirect: {
        interpretation: {
            vocab: "ltx",
            code: "coombs_direct"
        }
    },
    coombsIndirect: {
        interpretation: {
            vocab: "ltx",
            code: "coombs_indirect"
        }
    },
    ntProBNP: {
        interpretation: {
            vocab: "ltx",
            code: "NT-proBNP"
        }
    },
    bnp: {
        interpretation: {
            vocab: "ltx",
            code: "BNP"
        }
    },
    albumin: {
        interpretation: {
            vocab: "ltx",
            code: "serum_albumin"
        }
    },
    meldScore: {
        interpretation: {
            vocab: "ltx",
            code: "meld_score"
        }
    },
    meldNaScore: {
        interpretation: {
            vocab: "ltx",
            code: "meld_na_score"
        }
    },
    childPughScore: {
        interpretation: {
            vocab: "ltx",
            code: "child_pugh_score"
        }
    },
    calculatedChildPughClass: {
        interpretation: {
            vocab: "ltx",
            code: "calculated_child_pugh_classification"
        }
    },
    psa: {
        interpretation: {
            vocab: "ltx",
            code: "psa"
        }
    },
    medicalTreatment: {
        interpretation: {
            vocab: "ltx",
            code: "medical_treatment"
        }
    },
    fev1: {
        interpretation: {
            vocab: "ltx",
            code: "forced_expiratory_volume_1_second"
        }
    },
    fvc: {
        interpretation: {
            vocab: "ltx",
            code: "forced_vital_capacity"
        }
    },
    pef: {
        interpretation: {
            vocab: "ltx",
            code: "peak_expiratory_flow"
        }
    },
    mef75: {
        interpretation: {
            vocab: "ltx",
            code: "maximal_expiratory_flow_at_75"
        }
    },
    childPughClassification: {
        interpretation: {
            vocab: "ltx",
            code: "child_pugh_classification"
        }
    },
    varicealBleeding: {
        interpretation: {
            vocab: "ltx",
            code: "variceal_bleeding"
        }
    },
    encephalopathy: {
        interpretation: {
            vocab: "ltx",
            code: "encephalopathy"
        }
    },
    encephalopathyGrade: {
        interpretation: {
            vocab: "ltx",
            code: "encephalopathy_grade"
        }
    },
    hepatorenalSyndrome: {
        interpretation: {
            vocab: "ltx",
            code: "hepatorenal_syndrome"
        }
    },
    vaccineType: {
        interpretation: {
            vocab: "ltx",
            code: "vaccine_type"
        },
        limit: Infinity
    },
    addictionAssessment: {
        interpretation: {
            vocab: "ltx",
            code: "addiction_assessment"
        }
    },
    psychiatricAssessment: {
        interpretation: {
            vocab: "ltx",
            code: "psychiatric_assessment"
        }
    },
    psychologicalAssessment: {
        interpretation: {
            vocab: "ltx",
            code: "psychological_assessment"
        }
    },
    anesthesiology: {
        interpretation: {
            vocab: "ltx",
            code: "anesthesiology_result"
        }
    },
    ercp: {
        interpretation: {
            vocab: "ltx",
            code: "ercp"
        }
    },
    mrcp: {
        interpretation: {
            vocab: "ltx",
            code: "mrcp"
        }
    },
    liverBiopsy: {
        interpretation: {
            vocab: "ltx",
            code: "liver_biopsy"
        }
    },
    boneScan: {
        interpretation: {
            vocab: "ltx",
            code: "bone_scan"
        }
    },
    oncology: {
        interpretation: {
            vocab: "ltx",
            code: "oncology"
        }
    },
    otherConsultations: {
        interpretation: {
            vocab: "ltx",
            code: "other_consultation"
        }
    },
    liverElastography: {
        interpretation: {
            vocab: "ltx",
            code: "liver_elastography"
        }
    },
    fibrosisStage: {
        interpretation: {
            vocab: "ltx",
            code: "fibrosis_stage"
        }
    },
    steatosisGrade: {
        interpretation: {
            vocab: "ltx",
            code: "steatosis_grade"
        }
    },
    abdominalDopplerUltrasound: {
        interpretation: {
            vocab: "ltx",
            code: "abdominal_doppler_ultrasound_result"
        },
        limit: Infinity
    },
    ctAngiography: {
        interpretation: {
            vocab: "ltx",
            code: "CT_angiography_result"
        },
        limit: Infinity
    },
    angiographyIndirectPortography: {
        interpretation: {
            vocab: "ltx",
            code: "angiography_indirect_portography_result"
        },
        limit: Infinity
    },
    indicationForLiverTransplantation: {
        interpretation: {
            vocab: "ltx",
            code: "indication_for_liver_transplantation_comment"
        }
    },
    cardiovascularDiseases: {
        interpretation: {
            vocab: "ltx",
            code: "cardiovascular_disease"
        },
        limit: Infinity
    },
    endocrineDiseases: {
        interpretation: {
            vocab: "ltx",
            code: "endocrine_disease"
        },
        limit: Infinity
    },
    gastrointestinalDiseases: {
        interpretation: {
            vocab: "ltx",
            code: "gastrointestinal_disease"
        },
        limit: Infinity
    },
    nephrologicalAndUrologicalDiseases: {
        interpretation: {
            vocab: "ltx",
            code: "nephrological_urological_disease_comment"
        },
        limit: Infinity
    },
    respiratoryAndPulmonaryDiseases: {
        interpretation: {
            vocab: "ltx",
            code: "respiratory_pulmonary_disease"
        },
        limit: Infinity
    },
    surgicalProcedures: {
        interpretation: {
            vocab: "ltx",
            code: "surgical_procedures"
        }
    },
    thrombophilia: {
        interpretation: {
            vocab: "ltx",
            code: "thrombophilia_comment"
        },
        limit: Infinity
    },
    pregnanciesAndChildren: {
        interpretation: {
            vocab: "ltx",
            code: "pregnancies_and_children"
        }
    },
    allergiesAndSensitivities: {
        interpretation: {
            vocab: "ltx",
            code: "allergies_and_sensitivities_form"
        }
    },
    hbcAbIgg: {
        interpretation: {
            vocab: "ltx",
            code: "hbc_ab_igg"
        }
    },
    hbsAb: {
        interpretation: {
            vocab: "ltx",
            code: "hbs_ab"
        }
    },
    hbsAg: {
        interpretation: {
            vocab: "ltx",
            code: "hbs_ag"
        }
    },
    hbcAbIgm: {
        interpretation: {
            vocab: "ltx",
            code: "hbc_ab_igm"
        }
    },
    hcvScreening: {
        interpretation: {
            vocab: "ltx",
            code: "hepa_c_virus_screening"
        }
    },
    colitisUlcerosa: {
        interpretation: {
            vocab: "ltx",
            code: "colitis_ulcerosa"
        }
    },
    crohnDisease: {
        interpretation: {
            vocab: "ltx",
            code: "crohn_disease"
        }
    },
    ama: {
        interpretation: {
            vocab: "ltx",
            code: "ama"
        }
    },
    ana: {
        interpretation: {
            vocab: "ltx",
            code: "ana"
        }
    },
    antiCardiolipinAtIgG: {
        interpretation: {
            vocab: "ltx",
            code: "anti_cardiolipin_at_igg"
        }
    },
    antiCardiolipinAtIgM: {
        interpretation: {
            vocab: "ltx",
            code: "anti_cardiolipin_at_igm"
        }
    },
    antiCardiolipinAtIgA: {
        interpretation: {
            vocab: "ltx",
            code: "anti_cardiolipin_at_iga"
        }
    },
    cryoglobulin: {
        interpretation: {
            vocab: "ltx",
            code: "cryoglobulin"
        }
    },
    immunElfoIgG: {
        interpretation: {
            vocab: "ltx",
            code: "immun_elfo_igg"
        }
    },
    immunElfoIgA: {
        interpretation: {
            vocab: "ltx",
            code: "immun_elfo_iga"
        }
    },
    immunElfoIgM: {
        interpretation: {
            vocab: "ltx",
            code: "immun_elfo_igm"
        }
    },
    lkm: {
        interpretation: {
            vocab: "ltx",
            code: "lkm"
        }
    },
    pAnca: {
        interpretation: {
            vocab: "ltx",
            code: "panca"
        }
    },
    sma: {
        interpretation: {
            vocab: "ltx",
            code: "sma"
        }
    }
};
